<template lang="pug">
  div.body.body-table.bank-books-invoices
    div.table-choose-panel
      div.operation-information
        div.toolbar-table
          div.select.list &nbsp;

          div.toolbar.toolbar--modal
            div.line
              div.actions-panel

        div
          e-table-inner(
          ref="table"
          :itemsEndpoint="endpoint"
          @deleteItem="onDeleteItem"
          )
            div(
            slot="document"
            slot-scope="{row}"
            ).with-actions
              a(
              v-if="row.document"
              @click.stop.prevent="downloadDoc(row)"
              ) {{row.document}}

</template>

<script>
import { wasteGenerators } from '@/api/api-endpoints'
import saveFile from '@/utils/saveFile'

export default {
  name: 'bank-books-invoices',
  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    onDeleteItem(row) {
      this.$bar.start()
      this.$store
        .dispatch('deleteModel', {
          url: wasteGenerators.bankBookInvoiceRemove(row.id),
        })
        .then(() => {
          this.$bar.finish()
          this.$refs.table && this.$refs.table.updateTable()
        })
        .catch((e) => {
          this.$bar.finish()
          this.$e.errorBox(e)
        })
    },
    downloadDoc(row) {
      this.$bar.start()
      this.$store
        .dispatch('downloadFile', {
          endpoint: wasteGenerators.bankBookInvoiceDownload(row.id),
        })
        .then((r) => {
          this.$bar.finish()
          saveFile({
            blob: r.request.response,
            headers: r.headers,
          })
        })
        .catch((e) => {
          this.$bar.finish()
          this.$e.errorBox(e)
        })
    },
    endpoint(ctx) {
      let url = null
      if (this.model.id) {
        let route = {
          query: {
            sort: ctx.currentSort || null,
            page: ctx.paginateObj ? ctx.paginateObj.page : null,
            'per-page': ctx.paginateObj ? ctx.paginateObj['per-page'] : null,
          },
        }

        url = wasteGenerators.bankBookInvoices(this.model.id, route)
      }
      return {
        url,
      }
    },
  },
}
</script>
